
import { Component, Vue } from "vue-property-decorator";
import Title from "../components/title/title.vue";

@Component({
  components: { Title },
})
export default class Settings extends Vue {}
